import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Home from "./components/pages/Home";
import LoginComponent from "./components/pages/Login";
import ReclamoState from "./context/reclamo/ReclamoState";
import ParametrosState from "./context/Parametros/ParametrosState";
import TokenState from "./context/Token/TokenState";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import ValidacionComponent from "./components/pages/Validacion";
import ValidacionComponent2 from "./components/pages/Validacion#";
import ReactGA from 'react-ga';
import {useEffect, useState} from 'react';
ReactGA.initialize('G-XW3G92W3XM');

const App = () => {
  const [showPage] = useState(false)
  const [render, setRender] = useState(<></>)

  useEffect(() => {
    if(!showPage){
      window.location.replace("https://reclamos.superdesalud.gob.cl/")
    }else{
      ReactGA.pageview(window.location.pathname + window.location.search);
      setRender(
        <TokenState>
          <ParametrosState>
            <ReclamoState>
                <Switch>
                  <Route exact path="/" component={LoginComponent} />
                  <Route exact path="/formulario/" component={Home} />
                  <Route exact path="/validacion/" component={ValidacionComponent} />
                  <Route exact path="/validacion2/" component={ValidacionComponent2} />
                </Switch>
            </ReclamoState>
          </ParametrosState>
        </TokenState>
      )
    }
  }, [showPage])

  return (<>
    { render }
  </>);
};
export default App;